<template>
    <div class="lang">
        <div class="process">
            <div class="info on">
                <ul class="step-box">
                    <li class="step-box__item"><span class="step-box__item--step">STEP 01</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">安排预约</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 02</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">接收用品和确认预约电话</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 03</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">在接待处登记</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 04</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">咨询医生</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 05</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">付款</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 06</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">检查</h4>
                        </div>
                    </li>
                    <li class="step-box__item"><span class="step-box__item--step">STEP 07</span>
                        <div class="step-box__item__top">
                            <h4 class="title03">完成检查</h4>
                        </div>
                    </li>
                </ul>
            </div>

            <div class="info">
                <h3 class="bullet01">预约</h3>
                <p class="bullet03 depth">电话预约: 82-2-6986-2222~4</p>
                <p class="bullet03 depth">现场预约: 梨花女子大学首尔医院C楼3楼健康促进中心咨询台</p>
                <p class="bullet03 depth">在线预约: 您可以使用下面的底部按钮在线安排预约</p>
                <p class="bullet03 depth">联系时间: 09:00 - 17:00 (不包括星期六和节假日), 一旦医疗检查时间表确定, 您将接到护士的电话. 在安排医疗检查时，请提前告知我们您正在服用哪些药物.</p>
                <div class="botton-wrap"><a href="" class="main-button c-main">预约</a></div>
            </div>
            <div class="info">
                <h3 class="bullet01">接收用品和确认预约电话</h3>
                <p class="bullet03 depth">交付检查信息和安排检查后接收用品</p>
                <p class="bullet03 depth">我们将在体检前一周给您打一个确认电话(快乐电话).</p>
                <p class="bullet03 depth">体检前一天，通知消息(短信)将发送至您的手机.</p>
            </div>
            <div class="info">
                <h3 class="bullet01">在接待处登记</h3>
                <p class="bullet03 depth">检查预约并在健康促进中心咨询台登记，</p>
                <p class="bullet03 depth">提交用品 (调查表、粪便样本等)</p>
                <p class="bullet03 depth">检测和检查程序的说明</p>
            </div>
            <div class="info">
                <h3 class="bullet01">咨询医生</h3>
                <p class="bullet03 depth">在医疗检查开始前咨询医生并填写同意书</p>
            </div>
            <div class="info">
                <h3 class="bullet01">付款</h3>
                <p class="bullet03 depth">支付医疗检查费</p>
            </div>
            <div class="info">
                <h3 class="bullet01">检查</h3>
                <p class="bullet03 depth">脱掉衣服并穿上体检服和拖鞋 (不要携带任何物品，贵重物品可单独存放)</p>
                <p class="bullet03 depth">进行医疗检查 (3-6小时，视需要而定)</p>
            </div>
            <div class="info">
                <h3 class="bullet01">完成检查</h3>
                <p class="bullet03 depth">告知患者在家中应采取的预防措施 (提供餐券)</p>
                <p class="bullet03 depth">安排预约查看检查结果：选择就诊咨询或邮寄</p>
            </div>
        </div>
    </div>
</template>
<script>
    export default {

    }
</script>